/** Persistent anonymous fingerprint stored in localStorage. */
const KEY = "tbvh_fp";
export function getFingerprint() {
  try {
    let fp = localStorage.getItem(KEY);
    if (!fp) {
      fp = "fp_" + (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36));
      localStorage.setItem(KEY, fp);
    }
    return fp;
  } catch {
    return "fp_anon";
  }
}
